/* Submit the existing product form with its quantity, variant, and properties. */
if (!customElements.get('ameer-sticky-atc')) {
  customElements.define('ameer-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.mainButton = this.form?.querySelector('.product-form__submit');
      this.button = this.querySelector('button');
      if (!this.main || !this.form || !this.mainButton || !this.button) return;
      this.price = this.querySelector('[data-sticky-price]');
      this.quantity = this.querySelector('[data-sticky-quantity]');
      this.variantTitle = this.querySelector('[data-sticky-variant]');
      this.label = this.querySelector('[data-sticky-label]');
      this.error = this.querySelector('[data-sticky-error]');
      this.onSync = this.sync.bind(this);
      this.onClick = (event) => {
        this.sync();
        if (this.button.disabled) event.preventDefault();
      };
      this.button.addEventListener('click', this.onClick);
      this.main.addEventListener('input', this.onSync);
      this.main.addEventListener('change', this.onSync);
      this.mutationObserver = new MutationObserver(this.onSync);
      this.mutationObserver.observe(this.main, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'min', 'max', 'step', 'data-cart-quantity']
      });
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.dataset.section) this.sync();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onSync));
      }
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        document.body.classList.toggle('ameer-has-sticky-atc', !this.hidden);
        this.measure();
      }, { threshold: 0 });
      this.intersectionObserver.observe(this.mainButton);
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
      }
      if (document.querySelector('cart-drawer, cart-notification')) this.button.setAttribute('aria-haspopup', 'dialog');
      this.sync();
    }

    sync() {
      const variant = this.form.querySelector('[name="id"]');
      const busy = this.mainButton.getAttribute('aria-disabled') === 'true' || this.mainButton.classList.contains('loading');
      this.button.disabled = !variant?.value || variant.disabled || this.mainButton.disabled || busy;
      this.button.setAttribute('aria-busy', String(busy));
      this.label.textContent = busy ? this.dataset.loadingLabel : this.mainButton.querySelector('span')?.textContent.trim() || this.mainButton.textContent.trim();
      const priceContainer = document.getElementById(`price-${this.dataset.section}`);
      const mainPrice = priceContainer?.querySelector('.price');
      const amount = mainPrice?.querySelector(mainPrice.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular:not(s)');
      this.price.textContent = amount?.textContent.trim() || '';
      this.price.hidden = !amount || priceContainer.classList.contains('hidden');
      const quantityInput = this.form.elements.namedItem('quantity');
      this.quantity.textContent = this.dataset.quantityLabel.replace('[quantity]', quantityInput?.value || '1');
      try {
        const selected = JSON.parse(this.main.querySelector('[data-selected-variant]')?.textContent || 'null');
        this.variantTitle.textContent = selected?.title && selected.title !== 'Default Title' ? selected.title : '';
      } catch {
        this.variantTitle.textContent = '';
      }
      this.variantTitle.hidden = !this.variantTitle.textContent;
      const message = this.main.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      this.error.textContent = message?.textContent.trim() || '';
      this.error.hidden = !this.error.textContent;
    }

    measure() {
      document.documentElement.style.setProperty('--ameer-sticky-height', `${this.hidden ? 0 : this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.main?.removeEventListener('input', this.onSync);
      this.main?.removeEventListener('change', this.onSync);
      this.button?.removeEventListener('click', this.onClick);
      this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      document.body.classList.remove('ameer-has-sticky-atc');
      document.documentElement.style.removeProperty('--ameer-sticky-height');
    }
  });
}
